(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filters"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let filterButtons = document.querySelectorAll('.collectionFilters__filters.desktop-filters .collectionFilters__filter');
    let filterSelect = document.querySelector('.collectionFilters__filters.mobile-filters');
    let gridItems = document.querySelectorAll('.categorySlider__slider .product-card');
    let selectedTag = null;

    // Nowe zmienne do breadcrumbs
    let currentFilterSpan = document.querySelector('.breadcrumb__current.current_filter');
    let separatorFilterSpan = document.querySelector('.breadcrumb__separator.separator_filter');

    // Funkcja do pobierania wartości parametru URL
    function getParameterByName(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    // Sprawdzanie, czy w URL jest parametr "filter"
    let filterFromURL = getParameterByName('filter');

    if (filterFromURL) {
        // Jeśli parametr jest w URL, znajdź odpowiedni przycisk filtra
        let matchingButton = Array.from(filterButtons).find(button => button.getAttribute('data-tag') === filterFromURL);
        if (matchingButton) {
            matchingButton.classList.add('selected');
            selectedTag = filterFromURL;

            // Aktualizacja breadcrumbs na podstawie znalezionego przycisku
            let selectedName = matchingButton.getAttribute('data-name');
            updateBreadcrumb(selectedName);

            // Zaktualizuj select na mobile
            updateMobileSelect(selectedTag);
        }
    } else if (filterButtons.length > 0) {
        // Domyślne zaznaczenie pierwszego filtra
        let firstButton = filterButtons[0];
        firstButton.classList.add('selected');
        selectedTag = firstButton.getAttribute('data-tag');

        // Pobranie pierwszej nazwy i wstrzyknięcie jej do breadcrumbs
        let firstName = firstButton.getAttribute('data-name');
        updateBreadcrumb(firstName);

        // Zaktualizuj select na mobile
        updateMobileSelect(selectedTag);
    }

    filterGrid(); // Wywołanie filtrowania po ustawieniu filtra

    filterButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        filterButtons.forEach(function(btn) {
          btn.classList.remove('selected');
        });

        this.classList.add('selected');

        selectedTag = this.getAttribute('data-tag');
        let selectedName = this.getAttribute('data-name'); // Pobieranie wartości data-name

        updateBreadcrumb(selectedName); // Aktualizacja breadcrumbs

        // Zaktualizuj select na mobile
        updateMobileSelect(selectedTag);

        filterGrid();
      });
    });

    filterSelect.addEventListener('change', function() {
      let selectedOption = this.options[this.selectedIndex];
      selectedTag = selectedOption.getAttribute('data-tag');
      let selectedName = selectedOption.getAttribute('data-name'); // Pobieranie wartości data-name

      updateBreadcrumb(selectedName); // Aktualizacja breadcrumbs

      filterGrid();
    });

    function filterGrid() {
      if (!selectedTag) {
        gridItems.forEach(function(item) {
          item.style.display = 'block';
        });
        return;
      }

      gridItems.forEach(function(item) {
        let itemTags = item.getAttribute('data-tags').split(' ');
        let isVisible = itemTags.includes(selectedTag);
        item.style.display = isVisible ? 'block' : 'none';
      });
    }

    // Funkcja aktualizująca breadcrumbs
    function updateBreadcrumb(filterName) {
      if (filterName) {
        currentFilterSpan.textContent = filterName; // Wstrzykiwanie wartości data-name
        currentFilterSpan.style.display = 'inline-block'; // Ustawienie stylu
        separatorFilterSpan.style.display = 'inline-block'; // Ustawienie stylu
      } else {
        currentFilterSpan.style.display = 'none'; // Ukrywanie, jeśli brak filtra
        separatorFilterSpan.style.display = 'none';
      }
    }

    // Funkcja aktualizująca select na mobile
    function updateMobileSelect(selectedTag) {
      if (filterSelect) {
        let matchingOption = Array.from(filterSelect.options).find(option => option.getAttribute('data-tag') === selectedTag);
        if (matchingOption) {
          filterSelect.value = matchingOption.value; // Zmieniamy wartość selecta
        }
      }
    }
});

  document.addEventListener("DOMContentLoaded", function() {
    let lastScrollPosition = 0; // Zmienna przechowująca poprzednią pozycję scrolla

    document.addEventListener("scroll", function () {
      // Pobieramy obecną pozycję scrolla
      let currentScrollPosition = window.scrollY;

      // Pobieramy elementy, które chcemy zmodyfikować
      const stickyElements = document.querySelectorAll(
        "#shopify-section-template--23372320309573__collection_filters_eY6ink, " +
        "#shopify-section-template--23372320407877__collection_filters_KnpKin, " +
        "#shopify-section-template--23372320506181__collection_filters_eY6ink"
      );

      // Sprawdzamy, czy użytkownik przewija w górę
      if (currentScrollPosition < lastScrollPosition) {
        // Przewijanie w górę - ustawiamy top na 62px
        stickyElements.forEach(function (element) {
          element.style.top = "62px";
        });
      } else {
        // Przewijanie w dół lub brak przewijania - ustawiamy top na 0px
        stickyElements.forEach(function (element) {
          element.style.top = "0px";
        });
      }

      // Aktualizujemy ostatnią pozycję scrolla
      lastScrollPosition = currentScrollPosition;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  // customElements.define('localization-form', LocalizationForm);
    if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  window.showStickyHeader = true;
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if( window.showStickyHeader ) {
        if (scrollTop > this.currentScrollTop && scrollTop > 83) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > 83) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if( this.searchModal ) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

   document.addEventListener('DOMContentLoaded', function() {
    const collapsibleHeader = Array.from(document.getElementsByClassName('header__collapsible-header'));
    const chevronsHeader = Array.from(document.getElementsByClassName('header__chevron-down'));
    const collapsibleContentsHeader = Array.from(document.getElementsByClassName('header__collapsible-content'));
    
    collapsibleHeader.forEach((chevron, index) => chevron.addEventListener('click', (e) => {
        collapsibleContentsHeader[index].classList.toggle('expand');
        e.currentTarget.classList.toggle('active');
        
        // Ustawianie klasy 'active' dla odpowiedniego chevrona
        chevronsHeader[index].classList.toggle('active');
    }));
});

  document.addEventListener("DOMContentLoaded", function () {
  const stickyHeader = document.querySelector(".header-wrapper");
  let isAtTop = true;

  window.addEventListener("scroll", function () {
    if (window.scrollY === 0 && !isAtTop) {
      stickyHeader.classList.remove("header-wrapper--border");
      isAtTop = true;
    } else if (window.scrollY > 0 && isAtTop) {
      stickyHeader.classList.add("header-wrapper--border");
      isAtTop = false;
    }
  });
});

  function initMegaMenuCollapsibles(target = document) {
    const COLLAPSED_MAX_HEIGHT = 273;
    const EXPANDED_BUFFER = 42;
    const lists = target.querySelectorAll('.mega-menu-block__list--collapsible[data-collapsible="true"]');
    if (!lists.length) {
      return;
    }

    lists.forEach((list) => {
      if (list.dataset.collapsibleInitialized === 'true') {
        return;
      }
      const targetId = list.getAttribute('id');
      if (!targetId) {
        return;
      }
      const toggle = target.querySelector(`.mega-menu-block__toggle[data-target="${targetId}"]`) || document.querySelector(`.mega-menu-block__toggle[data-target="${targetId}"]`);
      if (!toggle) {
        return;
      }

      list.dataset.collapsibleInitialized = 'true';
      const collapsedLabel = toggle.dataset.collapsedText || toggle.textContent.trim() || 'Więcej +';
      const expandedLabel = toggle.dataset.expandedText || 'Ukryj';
      toggle.textContent = collapsedLabel;
      const listMenuContainer = list.closest('.list-menu--disclosure');
      const megaMenuBlock = list.closest('.mega-menu-block');
      const parentDetails = list.closest('details');
      const isMobileDrawer = Boolean(list.closest('.menu-drawer'));

      if (isMobileDrawer) {
        const readListScrollHeight = () => {
          let scrollHeight = list.scrollHeight;
          if (!scrollHeight) {
            const prevMaxHeight = list.style.maxHeight;
            const prevOverflow = list.style.overflow;
            list.style.maxHeight = 'none';
            list.style.overflow = 'visible';
            scrollHeight = list.scrollHeight;
            list.style.maxHeight = prevMaxHeight;
            list.style.overflow = prevOverflow;
          }
          return scrollHeight;
        };

        const applyMobileHeights = () => {
          const scrollHeight = readListScrollHeight();
          if (!scrollHeight) {
            list.dataset.collapsedHeight = COLLAPSED_MAX_HEIGHT;
            list.dataset.expandedHeight = COLLAPSED_MAX_HEIGHT + EXPANDED_BUFFER;
            list.style.maxHeight = `${list.dataset.expanded === 'true' ? list.dataset.expandedHeight : list.dataset.collapsedHeight}px`;
            return;
          }
          const collapsedHeight = Math.min(scrollHeight, COLLAPSED_MAX_HEIGHT);
          const expandedHeight = scrollHeight + EXPANDED_BUFFER;
          list.dataset.collapsedHeight = collapsedHeight;
          list.dataset.expandedHeight = expandedHeight;
          if (list.dataset.expanded === 'true') {
            list.style.maxHeight = `${expandedHeight}px`;
          } else {
            list.style.maxHeight = `${collapsedHeight}px`;
          }
        };

        list.dataset.expanded = 'false';
        applyMobileHeights();

        const mobileToggleHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
          }
          const isExpanded = list.dataset.expanded === 'true';
          list.dataset.expanded = isExpanded ? 'false' : 'true';
          toggle.textContent = isExpanded ? collapsedLabel : expandedLabel;
          if (list.dataset.expanded === 'true') {
            list.style.maxHeight = `${list.dataset.expandedHeight}px`;
          } else {
            list.style.maxHeight = `${list.dataset.collapsedHeight}px`;
          }
        };

        toggle.addEventListener('click', mobileToggleHandler, true);

        window.addEventListener('resize', applyMobileHeights);

        if (parentDetails) {
          parentDetails.addEventListener('toggle', () => {
            if (!parentDetails.open && list.dataset.collapsedHeight) {
              list.dataset.expanded = 'false';
              list.style.maxHeight = `${list.dataset.collapsedHeight}px`;
              toggle.textContent = collapsedLabel;
            } else if (parentDetails.open) {
              requestAnimationFrame(() => requestAnimationFrame(applyMobileHeights));
            }
          });
        }

        return;
      }

      const getBlockLists = () => {
        if (!megaMenuBlock) {
          return [];
        }
        return Array.from(megaMenuBlock.querySelectorAll('.mega-menu-block__list--collapsible[data-collapsible="true"]'));
      };

      const hasOtherExpandedLists = () => {
        return getBlockLists().some((candidate) => candidate !== list && candidate.dataset.expanded === 'true');
      };

      const setContainerTargetHeight = (blockHeight, shouldExpand) => {
        if (!listMenuContainer) {
          return;
        }
        if (shouldExpand && blockHeight > 0) {
          const styles = window.getComputedStyle(listMenuContainer);
          const paddingTop = parseFloat(styles.paddingTop) || 0;
          const paddingBottom = parseFloat(styles.paddingBottom) || 0;
          const totalHeight = blockHeight + paddingTop + paddingBottom + EXPANDED_BUFFER;
          listMenuContainer.classList.add('mega-menu--expanded');
          listMenuContainer.style.height = `${totalHeight}px`;
        } else {
          listMenuContainer.classList.remove('mega-menu--expanded');
          listMenuContainer.style.removeProperty('height');
        }
      };

      const syncContainerHeight = () => {
        if (!listMenuContainer || !megaMenuBlock) {
          return;
        }
        const anyExpanded = megaMenuBlock.querySelector('.mega-menu-block__list--collapsible[data-collapsible="true"][data-expanded="true"]');
        if (anyExpanded) {
          const blockHeight = Math.ceil(megaMenuBlock.getBoundingClientRect().height);
          setContainerTargetHeight(blockHeight, true);
        } else {
          setContainerTargetHeight(0, false);
        }
      };

      const measureBlockHeightForState = ({ simulatedList = null, simulatedExpanded = null } = {}) => {
        if (!megaMenuBlock) {
          return 0;
        }
        const blockLists = getBlockLists();
        if (!blockLists.length) {
          return Math.ceil(megaMenuBlock.getBoundingClientRect().height);
        }
        const snapshots = blockLists.map((candidate) => ({
          element: candidate,
          transition: candidate.style.transition,
          maxHeight: candidate.style.maxHeight,
        }));
        blockLists.forEach((candidate) => {
          const shouldExpand = candidate === simulatedList && typeof simulatedExpanded === 'boolean'
            ? simulatedExpanded
            : candidate.dataset.expanded === 'true';
          const datasetKey = shouldExpand ? 'expandedHeight' : 'collapsedHeight';
          const fallbackHeight = shouldExpand
            ? candidate.scrollHeight + EXPANDED_BUFFER
            : Math.min(candidate.scrollHeight, COLLAPSED_MAX_HEIGHT);
          const targetValue = Number(candidate.dataset[datasetKey]) || fallbackHeight;
          candidate.style.transition = 'none';
          candidate.style.maxHeight = `${targetValue}px`;
        });
        const blockHeight = Math.ceil(megaMenuBlock.getBoundingClientRect().height);
        snapshots.forEach(({ element, transition, maxHeight }) => {
          element.style.transition = transition || '';
          element.style.maxHeight = maxHeight || '';
        });
        return blockHeight;
      };

      const applyHeights = () => {
        const scrollHeight = list.scrollHeight;
        const collapsedHeight = Math.min(scrollHeight, COLLAPSED_MAX_HEIGHT);
        const expandedHeight = scrollHeight + EXPANDED_BUFFER;
        list.dataset.collapsedHeight = collapsedHeight;
        list.dataset.expandedHeight = expandedHeight;
        if (list.dataset.expanded === 'true') {
          list.style.maxHeight = `${expandedHeight}px`;
        } else {
          list.style.maxHeight = `${collapsedHeight}px`;
        }
        syncContainerHeight();
      };

      list.dataset.expanded = 'false';
      applyHeights();

      toggle.addEventListener('click', () => {
        const isExpanded = list.dataset.expanded === 'true';
        const collapsedHeightValue = Number(list.dataset.collapsedHeight || COLLAPSED_MAX_HEIGHT);
        const expandedHeightValue = Number(list.dataset.expandedHeight || collapsedHeightValue);
        const willExpand = !isExpanded;
        const blockHeightTarget = measureBlockHeightForState({
          simulatedList: list,
          simulatedExpanded: willExpand,
        });
        const otherExpanded = hasOtherExpandedLists();
        const anyExpandedAfterToggle = willExpand || otherExpanded;
        list.dataset.expanded = willExpand ? 'true' : 'false';
        if (willExpand) {
          list.style.maxHeight = `${expandedHeightValue}px`;
          toggle.textContent = expandedLabel;
        } else {
          list.style.maxHeight = `${collapsedHeightValue}px`;
          toggle.textContent = collapsedLabel;
        }
        const normalizedTarget = blockHeightTarget || Math.ceil(megaMenuBlock ? megaMenuBlock.getBoundingClientRect().height : 0);
        if (anyExpandedAfterToggle) {
          setContainerTargetHeight(normalizedTarget, true);
        } else {
          setContainerTargetHeight(0, false);
        }
      });

      window.addEventListener('resize', () => {
        applyHeights();
        syncContainerHeight();
      });

      if (parentDetails) {
        parentDetails.addEventListener('toggle', () => {
          if (!parentDetails.open) {
            if (list.dataset.expanded === 'true' && list.dataset.collapsedHeight) {
              list.dataset.expanded = 'false';
              list.style.maxHeight = `${list.dataset.collapsedHeight}px`;
              toggle.textContent = collapsedLabel;
            }
            setContainerTargetHeight(0, false);
            return;
          }
          requestAnimationFrame(() => {
            applyHeights();
          });
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initMegaMenuCollapsibles());
  document.addEventListener('shopify:section:load', (event) => {
    if (event && event.target) {
      initMegaMenuCollapsibles(event.target);
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    function getViewportHeight() {
      if (window.visualViewport && window.visualViewport.height) {
        return Math.round(window.visualViewport.height);
      }
      return Math.round(window.innerHeight);
    }

    function setMenuDrawerHeight() {
      const menuDrawer = document.getElementById('menu-drawer');
      if (!menuDrawer) return;

      const announcementBar = document.querySelector('.announcement-bar-new');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const viewportHeight = getViewportHeight();
      const menuHeightPx = Math.max(viewportHeight - 62 - announcementBarHeight, 0);
      const menuHeight = `${menuHeightPx}px`;

      menuDrawer.style.height = menuHeight;
      document.documentElement.style.setProperty('--menu-drawer-height', menuHeight);
    }

    function syncSubmenuState() {
      const menuDrawer = document.getElementById('menu-drawer');
      if (!menuDrawer) return;
      const hasOpenSubmenu = Boolean(menuDrawer.querySelector('details.menu-opening[open]'));
      menuDrawer.classList.toggle('menu-drawer--submenu-open', hasOpenSubmenu);
    }

    setMenuDrawerHeight();
    syncSubmenuState();

    window.addEventListener('resize', setMenuDrawerHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setMenuDrawerHeight);
    }

    const drawerDetails = document.querySelectorAll('.menu-drawer-container details');
    drawerDetails.forEach((details) => {
      details.addEventListener('toggle', syncSubmenuState);
    });

    const menuDrawer = document.getElementById('menu-drawer');
    if (menuDrawer) {
      menuDrawer.addEventListener('click', (event) => {
        const target = event.target;
        if (!target) return;
        const summary = target.closest('summary.menu-drawer__menu-item');
        const closeButton = target.closest('.menu-drawer__close-button');
        if (summary || closeButton) {
          requestAnimationFrame(syncSubmenuState);
          setTimeout(syncSubmenuState, 50);
        }
      });
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-article-interview"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.v2-article');
    if (!root) return;
    var toc = root.querySelector('.v2-article__toc');
    var nav = root.querySelector('.v2-article__toc nav');
    var heads = root.querySelectorAll('.v2-article__main h2');
    if (!toc || !nav) return;
    if (!heads.length) {
      toc.style.display = 'none';
      return;
    }
    Array.prototype.forEach.call(heads, function (h, i) {
      if (!h.id) h.id = 'sekcja-' + (i + 1);
      h.style.scrollMarginTop = '96px';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      nav.appendChild(a);
    });
    var links = nav.querySelectorAll('a');
    function setActive() {
      var idx = -1;
      Array.prototype.forEach.call(heads, function (h, i) {
        if (h.getBoundingClientRect().top <= 140) idx = i;
      });
      var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
      if (atBottom) idx = heads.length - 1;
      Array.prototype.forEach.call(links, function (l) { l.removeAttribute('aria-current'); });
      if (idx >= 0 && links[idx]) links[idx].setAttribute('aria-current', 'true');
    }
    window.addEventListener('scroll', setActive, { passive: true });
    setActive();

    var spacer = root.querySelector('.v2-article__end-spacer');
    Array.prototype.forEach.call(links, function (a) {
      a.addEventListener('click', function () {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target || !spacer) return;
        var targetY = target.getBoundingClientRect().top + window.scrollY - 96;
        var maxY = document.documentElement.scrollHeight - window.innerHeight;
        if (targetY > maxY) spacer.style.height = (targetY - maxY + 8) + 'px';
      });
    });
    window.addEventListener('scroll', function () {
      if (!spacer || !spacer.style.height) return;
      var baseMax = document.documentElement.scrollHeight - parseFloat(spacer.style.height) - window.innerHeight;
      if (window.scrollY < baseMax - 40) spacer.style.height = '';
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-article-post"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.v2-article');
    if (!root) return;
    var toc = root.querySelector('.v2-article__toc');
    var nav = root.querySelector('.v2-article__toc nav');
    var heads = root.querySelectorAll('.v2-article__main h2');
    if (!toc || !nav) return;
    if (!heads.length) {
      toc.style.display = 'none';
      return;
    }
    Array.prototype.forEach.call(heads, function (h, i) {
      if (!h.id) h.id = 'sekcja-' + (i + 1);
      h.style.scrollMarginTop = '96px';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      nav.appendChild(a);
    });
    var links = nav.querySelectorAll('a');
    function setActive() {
      var idx = -1;
      Array.prototype.forEach.call(heads, function (h, i) {
        if (h.getBoundingClientRect().top <= 140) idx = i;
      });
      var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
      if (atBottom) idx = heads.length - 1;
      Array.prototype.forEach.call(links, function (l) { l.removeAttribute('aria-current'); });
      if (idx >= 0 && links[idx]) links[idx].setAttribute('aria-current', 'true');
    }
    window.addEventListener('scroll', setActive, { passive: true });
    setActive();

    var spacer = root.querySelector('.v2-article__end-spacer');
    Array.prototype.forEach.call(links, function (a) {
      a.addEventListener('click', function () {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target || !spacer) return;
        var targetY = target.getBoundingClientRect().top + window.scrollY - 96;
        var maxY = document.documentElement.scrollHeight - window.innerHeight;
        if (targetY > maxY) spacer.style.height = (targetY - maxY + 8) + 'px';
      });
    });
    window.addEventListener('scroll', function () {
      if (!spacer || !spacer.style.height) return;
      var baseMax = document.documentElement.scrollHeight - parseFloat(spacer.style.height) - window.innerHeight;
      if (window.scrollY < baseMax - 40) spacer.style.height = '';
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-article-recipe"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.v2-article');
    if (!root) return;
    var toc = root.querySelector('.v2-article__toc');
    var nav = root.querySelector('.v2-article__toc nav');
    var heads = root.querySelectorAll('.v2-article__main h2');
    if (!toc || !nav) return;
    if (!heads.length) {
      toc.style.display = 'none';
      return;
    }
    Array.prototype.forEach.call(heads, function (h, i) {
      if (!h.id) h.id = 'sekcja-' + (i + 1);
      h.style.scrollMarginTop = '96px';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      nav.appendChild(a);
    });
    var links = nav.querySelectorAll('a');
    function setActive() {
      var idx = -1;
      Array.prototype.forEach.call(heads, function (h, i) {
        if (h.getBoundingClientRect().top <= 140) idx = i;
      });
      var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
      if (atBottom) idx = heads.length - 1;
      Array.prototype.forEach.call(links, function (l) { l.removeAttribute('aria-current'); });
      if (idx >= 0 && links[idx]) links[idx].setAttribute('aria-current', 'true');
    }
    window.addEventListener('scroll', setActive, { passive: true });
    setActive();

    var spacer = root.querySelector('.v2-article__end-spacer');
    Array.prototype.forEach.call(nav.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target || !spacer) return;
        var targetY = target.getBoundingClientRect().top + window.scrollY - 96;
        var maxY = document.documentElement.scrollHeight - window.innerHeight;
        if (targetY > maxY) spacer.style.height = (targetY - maxY + 8) + 'px';
      });
    });
    window.addEventListener('scroll', function () {
      if (!spacer || !spacer.style.height) return;
      var baseMax = document.documentElement.scrollHeight - parseFloat(spacer.style.height) - window.innerHeight;
      if (window.scrollY < baseMax - 40) spacer.style.height = '';
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
